import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { AgentStatusEnum } from '../enums/agent-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function agentStatusToColor(status: AgentStatusEnum): string {
	switch (status) {
		case AgentStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case AgentStatusEnum.ON_HOLD:
			return RecordColorEnum.RED;

		case AgentStatusEnum.CLOSED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
